<div class="cf sectnav mobile-responsive">
    @if (appFacadeService.getActiveTab() | async; as activeTab) {
    <ul class="por-menu">
        @for (url of navigations; track url) {
        <li class="navigations theme-list-item">
            @if (url?.tab === 'AdminDifference') {
            <span>
                <a href="https://www.point-of-rental.com/ecommerce/consumer-portal/" target="_blank">{{ url?.text }}</a>
            </span>
            } @if (url?.tab !== 'AdminDifference') {
            <span>
                <por-base-button [ngClass]="{ 'is-active': url?.tab === activeTab }" (click)="toggleTab(url?.tab)" [featureName]="url?.tab || ''">
                    <span>{{ url?.text }}</span>
                </por-base-button>
            </span>
            }
        </li>
        }
    </ul>
    }
</div>
